import React from 'react';
import { cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';
import { Box } from '@atlaskit/primitives';

const styles = cssMap({
  footerLogo: {
    marginTop: token('space.100'),
  },
});

export const FooterLogoWrapper = ({ children }: { children: React.ReactNode }) => (
  <Box xcss={styles.footerLogo}>{children}</Box>
);
